// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ResourcePermissionSchema } from './v1/resourcePermissionSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const showResourcePermissionsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  resource: z.coerce.string().describe("Resource name (e.g., user, project, hour)"),
});

export const showResourcePermissionsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Resource permissions retrieved successfully
 */
export const showResourcePermissions200Schema = z.lazy(() => v1ResourcePermissionSchema);

/**
 * @description Unauthorized
 */
export const showResourcePermissions401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const showResourcePermissionsQueryResponseSchema = z.lazy(() => showResourcePermissions200Schema);
